import { AddressMapLatLng } from '@ravago/shared/page-data/models/elements';

export const convertStringToLatLng = (latLng?: string): AddressMapLatLng => {
   if (!latLng) return { lat: 0, lng: 0 };

   const parts = latLng.split(',').map((part) => parseFloat(part.trim()));

   if (parts.length !== 2 || parts.some((part) => Number.isNaN(part))) {
      return { lat: 0, lng: 0 };
   }

   const [lat, lng] = parts;

   return { lat, lng };
};

export const convertLatLngToString = (latLng?: AddressMapLatLng): string => {
   if (!latLng || typeof latLng.lat !== 'number' || typeof latLng.lng !== 'number') {
      return '';
   }

   return `${latLng.lat.toFixed(6)}, ${latLng.lng.toFixed(6)}`;
};

export const getLocationDetails = ({ formattedAddress, internationalPhoneNumber }: google.maps.places.Place): string =>
   `${internationalPhoneNumber ? `${internationalPhoneNumber}\n\n` : ''}${formattedAddress ?? ''}`;
